import { createTheme } from '@mui/material'
import { variables } from './theme'
import { baseFormTheme } from '../base/useTheme'

const formTheme = {
    ...baseFormTheme,
}

export const useTheme = props => {
    const themes = {
        formTheme: createTheme({ ...formTheme, ...variables }),
    }

    props &&
        Object.keys(props).forEach(key => {
            themes[key].components = {
                ...themes[key].components,
                ...props[key],
            }
        })

    return { ...themes }
}
